<script setup>
import Logo from '@/Shared/SVG/Logo';
import ButtonShape from '@/Shared/ButtonShape';
import { reactive } from 'vue';
import SubscribeModal from '@/Shared/Modals/SubscribeModal';
import DiscordIcon from '@/Shared/SVG/DiscordIcon';
import TwitterIcon from '@/Shared/SVG/TwitterIcon';
import InstagramIcon from '@/Shared/SVG/InstagramIcon';
import YoutubeIcon from '@/Shared/SVG/YoutubeIcon';
import SubscribeIcon from '@/Shared/SVG/SubscribeIcon';
import LinkedinIcon from '@/Shared/SVG/LinkedinIcon.vue';
import TelegramIcon from '@/Shared/SVG/TelegramIcon.vue';
import FacebookIcon from '@/Shared/SVG/FacebookIcon.vue';
import RedditIcon from '@/Shared/SVG/RedditIcon.vue';
import MediumIcon from '@/Shared/SVG/MediumIcon.vue';
import CoinGeckoIcon from '@/Shared/SVG/CoinGeckoIcon.vue';

let props = defineProps({
    errors: Object,
});

let newsletterSettings = reactive({
    subscribeModalIsOpen: false,
});
</script>

<template>
    <SubscribeModal
        :open="newsletterSettings.subscribeModalIsOpen"
        :errors="errors"
        @close="newsletterSettings.subscribeModalIsOpen = false"
    >
    </SubscribeModal>
    <div class="mx-4 mb-20 lg:mx-0">
        <div class="mb-14">
            <Logo class="m-auto w-44"></Logo>
            <p class="mt-2 text-center uppercase text-white text-opacity-60">
                The new gaming era!
            </p>
        </div>
        <div class="mb-14 rounded-2xl bg-wgn-blue-1">
            <div
                class="flex flex-col items-center justify-between space-y-7 p-6 md:flex-row md:space-y-0 md:px-[50px] md:py-[40px]"
            >
                <div>
                    <p class="flex items-center text-white text-opacity-70">
                        <SubscribeIcon class="mr-2 opacity-70" />Subscribe to
                        our newsletter to keep up to date
                    </p>
                </div>
                <div class="h-[58px] items-center p-1 drop-shadow-none">
                    <button
                        @click.prevent="
                            newsletterSettings.subscribeModalIsOpen = true
                        "
                    >
                        <ButtonShape
                            type="blue"
                            class="flex h-[50px] items-center drop-shadow-none"
                        >
                            <span>Subscribe</span>
                        </ButtonShape>
                    </button>
                </div>
            </div>
        </div>
        <div
            class="grid grid-cols-1 border-b border-white border-opacity-20 pb-20 md:grid-cols-5"
        >
            <div class="flex hidden flex-col space-y-4 md:block">
                <Link
                    :href="route('platform.build')"
                    class="block font-medium text-white"
                    >Platform</Link
                >
                <Link
                    :href="route('platform.build')"
                    class="block text-white text-opacity-70"
                    >Building</Link
                >
                <Link
                    :href="route('platform.apis')"
                    class="block text-white text-opacity-70"
                    >APIs</Link
                >
                <Link
                    :href="route('platform.nodes')"
                    class="block text-white text-opacity-70"
                    >Nodes</Link
                >
            </div>
            <div class="flex hidden flex-col space-y-4 md:block">
                <Link
                    :href="route('gaming.gameHub')"
                    class="block font-medium text-white"
                    >Gaming</Link
                >
                <Link
                    :href="route('gaming.gameHub')"
                    class="block text-white text-opacity-70"
                    >Game Hub</Link
                >
                <Link
                    :href="route('gaming.gameStore')"
                    class="block text-white text-opacity-70"
                    >Game Store</Link
                >
                <Link
                    :href="route('gaming.marketplace')"
                    class="block text-white text-opacity-70"
                    >Marketplace</Link
                >
                <Link
                    :href="route('gaming.incubation')"
                    class="block text-white text-opacity-70"
                    >Incubation</Link
                >
                <Link
                    :href="route('gaming.hosting')"
                    class="block text-white text-opacity-70"
                    >Hosting</Link
                >
                <Link
                    :href="route('gaming.development')"
                    class="block text-white text-opacity-70"
                    >Development</Link
                >
            </div>
            <div class="flex hidden flex-col space-y-4 md:block">
                <Link
                    :href="route('finance')"
                    class="block font-medium text-white"
                    >Finance</Link
                >
                <a
                    href="https://wallet.wodo.io/wallet"
                    class="block text-white text-opacity-70"
                    >Wodo Wallet</a
                >
            </div>
            <div class="flex hidden flex-col space-y-4 md:block">
                <Link
                    :href="route('company.about')"
                    class="block font-medium text-white"
                    >Company</Link
                >
                <Link
                    :href="route('company.about')"
                    class="block text-white text-opacity-70"
                    >About</Link
                >
                <Link
                    :href="route('company.team')"
                    class="block text-white text-opacity-70"
                    >Team</Link
                >
                <Link
                    :href="route('company.partners')"
                    class="block text-white text-opacity-70"
                    >Partners</Link
                >
                <Link
                    :href="route('company.legal')"
                    class="block text-white text-opacity-70"
                    >Legal</Link
                >
                <!-- <Link
                    :href="route('company.privacyPolicy')"
                    class="block text-white text-opacity-70"
                    >Privacy Policy</Link
                > -->
            </div>
            <div class="flex flex-col space-y-4">
                <p class="font-medium text-white">Contact Information</p>
                <div class="flex flex-col text-white text-opacity-70">
                    <span>info@wodo.io</span>
                    <span>+90 (850) 441 24 13</span>
                </div>
                <div class="flex flex-shrink-0 flex-col space-y-4">
                    <div
                        class="flex flex-shrink-0 flex-wrap items-center space-x-4"
                    >
                        <a href="https://twitter.com/wodoio" target="_blank">
                            <TwitterIcon
                                class="text-wgl-gray-1 opacity-70"
                            ></TwitterIcon>
                        </a>
                        <a href="https://t.me/wodocommunity" target="_blank">
                            <TelegramIcon
                                class="text-wgl-gray-1 opacity-70"
                            ></TelegramIcon>
                        </a>
                        <a href="https://discord.gg/fbyns8Egpb" target="_blank">
                            <DiscordIcon
                                class="text-wgl-gray-1 opacity-70"
                            ></DiscordIcon>
                        </a>
                        <a
                            href="https://www.youtube.com/c/Wodoio"
                            target="_blank"
                        >
                            <YoutubeIcon
                                class="text-wgl-gray-1 opacity-70"
                            ></YoutubeIcon>
                        </a>
                        <a
                            href="https://www.linkedin.com/company/wodonetwork/"
                            target="_blank"
                        >
                            <LinkedinIcon
                                class="text-wgl-gray-1 opacity-70"
                            ></LinkedinIcon>
                        </a>
                        <a
                            href="https://www.instagram.com/wodoio"
                            target="_blank"
                        >
                            <InstagramIcon
                                class="text-wgl-gray-1 opacity-70"
                            ></InstagramIcon>
                        </a>
                    </div>
                    <div
                        class="flex flex-shrink-0 flex-wrap items-center space-x-4"
                    >
                        <a
                            href="https://www.facebook.com/wodonetwork/"
                            target="_blank"
                        >
                            <FacebookIcon
                                class="text-wgn-gray-1 opacity-70"
                            ></FacebookIcon>
                        </a>
                        <a
                            href="https://www.reddit.com/r/wodoio/"
                            target="_blank"
                        >
                            <RedditIcon
                                class="text-wgn-gray-1 opacity-70"
                            ></RedditIcon>
                        </a>
                        <a href="https://wodoio.medium.com" target="_blank">
                            <MediumIcon
                                class="text-wgn-gray-1 opacity-70"
                            ></MediumIcon>
                        </a>
                        <a
                            href="https://www.coingecko.com/en/coins/wodo-gaming"
                            target="_blank"
                        >
                            <CoinGeckoIcon
                                class="text-wgn-gray-1 opacity-70"
                            ></CoinGeckoIcon>
                        </a>
                        <a
                            href="https://cryptorank.io/price/wodo-gaming"
                            target="_blank"
                        >
                            <img
                                class="m-auto h-5 w-5 opacity-70"
                                src="/images/cryptorankIcon.webp"
                                alt="cryptorank"
                            />
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div class="m-auto mt-12 max-w-7xl">
            <p class="text-center text-white text-opacity-40">
                © 2024 Wodo Network
            </p>
            <div
                class="mt-8 mb-6 grid grid-cols-1 gap-8 text-white text-opacity-40 md:grid-cols-2"
            >
                <div>
                    <p>
                        Our vision is to accelerate the transformation of the
                        gaming ecosystem to a new era built around Blockchain
                        and Metaverse technologies and to establish a community
                        as a reference point through curating simple, practical,
                        innovative solutions.
                    </p>
                </div>
                <div>
                    <p>
                        We cultivate transparency and respect in our
                        organization and reflect the same value to our community
                        and partners. We strive to communicate entirely in an
                        open way towards our community and partners.
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>
